import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { FeedbackCategory, FEEDBACK_CATEGORIES } from '../../ai.models';
import { PebblModalComponent } from '../../../shared/components/pebbl-modal/pebbl-modal.component';

/** Payload emitted when the user submits thumbs-down feedback. */
export interface FeedbackDetail {
  category: FeedbackCategory;
  text: string;
}

/**
 * Modal shown when the user clicks thumbs-down on an assistant message. Collects a
 * category (dropdown) and an optional free-text note (textarea), then emits the pair
 * to the parent, which forwards it to the store. Purely presentational — it owns no
 * network calls and no feedback state beyond the in-progress form.
 */
@Component({
  selector: 'app-chat-feedback-popup',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule, PebblModalComponent],
  templateUrl: './chat-feedback-popup.component.html',
  styleUrls: [
    './chat-feedback-popup.component.css',
    '../../../shared/components/pebbl-modal/pebbl-dialog.css',
  ],
})
export class ChatFeedbackPopupComponent {
  @Output() submitted = new EventEmitter<FeedbackDetail>();
  @Output() cancelled = new EventEmitter<void>();

  readonly categories = FEEDBACK_CATEGORIES;
  category: FeedbackCategory | null = null;
  text = '';

  /** Both a category and a non-empty message are required by the API. */
  get canSubmit(): boolean {
    return !!this.category && this.text.trim().length > 0;
  }

  cancel(): void {
    this.cancelled.emit();
  }

  submit(): void {
    if (!this.canSubmit || !this.category) return;
    this.submitted.emit({ category: this.category, text: this.text.trim() });
  }
}
